// src/store/usePlaylistStore.js
import { defineStore } from 'pinia';
import { ref, watch, nextTick } from 'vue';
import axios from 'axios';

export const usePlaylistStore = defineStore('playlist', {
  state: () => ({
    playlist: [],
    currentSongId: null,
    maxItems: 15,
    currentPlayingSong: null,
  }),

  actions: {
    addSong(song) {
      console.log("待播", this.playlist.length);
      if (this.playlist.length < this.maxItems) {
        this.playlist.push({
          id: song.id,
          songname: song.songname,
          filename: song.filename,
          stateA: false,
          stateB: false,
        });
      } else {
        console.warn('Playlist is full');
      }
    },
    removeSong(songId) {
      console.log('Removing song with ID:', songId);
      const index = this.playlist.findIndex(song => song.id === songId);
      console.log('Found at index:', index);
      if (index !== -1) {
        this.playlist.splice(index, 1);
        console.log('Song removed, new playlist length:', this.playlist.length);
      }
    },
    moveSongUp(index) {
      if (index > 0 && this.playlist) {
        const song = this.playlist.splice(index, 1)[0];
        this.playlist.splice(index - 1, 0, song);
        // 強制刷新
        nextTick();
      }
    },
    clearPlaylist() {
      this.playlist = [];
    },
    setCurrentSongId(id) {
      this.currentSongId = id;
    },
    clearCurrentSongId() {
      this.currentSongId = null;
    },
    async downloadSong(songname) {
      try {
        const response = await axios.get(`/api/download?songname=${songname}`, {
          responseType: 'blob',
        });
        return response.data;
      } catch (error) {
        console.error('Download failed', error);
        return null;
      }
    },
    saveFile(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    setCurrentPlayingSong(song) {
      this.currentPlayingSong = song;
      // console.log('當前播放歌曲已更新:', song);
    },
    getCurrentPlayingSong() {
      return this.currentPlayingSong;
    },
  },

  getters: {
    getCurrentSongId: (state) => state.currentSongId,
    getPlaylist: (state) => state.playlist,
    getCurrentPlayingSongInfo: (state) => state.currentPlayingSong
  }
});


